import {
  SET_OL_MAP,
  SET_CENTER,
  ZOOM_IN,
  ZOOM_OUT,
  SET_ZOOM,
  SET_TILE_LOADING,
  SET_TILE_LOADED,
  SET_AREA_DRAWING,
  CLEAR_AREA_DRAWING,
  SET_AREA,
  SET_LEGEND_DATA,
  SET_BASE_MAP,
  SET_TYPE,
  SET_DEFORMATION_RATE_INTERVAL_VALUE,
  SET_CHART_CONTAINER_OPEN,
  SET_BASE_MAP_LIST_VISIBLE,
  SET_INFO_BOX_OPEN,
  SET_MAP_LAYERS,
  SET_CHENGELOG_BOX_OPEN
} from '../actionTypes'

const mapState = {
  olMap: null,
  zoom: 9,
  isChartContainerOpen: false,
  center: [22.5, 48.4],
  loadingTiles: 0,
  baseMap: 'Esri_DarkGray',
  loadedTiles: 0,
  isAreaDrawingEnabled: false,
  clearAreaDrawing: false,
  selectedArea: null,
  legendData: null,
  isBaseMapListVisibly: false,
  isInfoBoxOpen: false,
  isChangelogBoxOpen: false,
  type: 'LOS',
  activeMapLayers: ["countryBorder"],
  deformationRateIntervalValue: 0
}

const mapReducer = (state = mapState, { type = '', payload = {} }) => {
  switch (type) {
    case SET_OL_MAP: {
      return {
        ...state,
        olMap: payload,
      }
    }
    case SET_INFO_BOX_OPEN: {
      return {
        ...state,
        isInfoBoxOpen: payload,
      }
    }
    case SET_CHENGELOG_BOX_OPEN: {
      return {
        ...state,
        isChangelogBoxOpen: payload,
      }
    }
    case SET_BASE_MAP_LIST_VISIBLE: {
      return {
        ...state,
        isBaseMapListVisibly: payload,
      }
    }

    case SET_MAP_LAYERS: {
      return {
        ...state,
        activeMapLayers: payload,
      }
    }

    case SET_CHART_CONTAINER_OPEN: {
      return {
        ...state,
        isChartContainerOpen: payload,
      }
    }

    case SET_TYPE: {
      return {
        ...state,
        type: payload,
      }
    }

    case SET_DEFORMATION_RATE_INTERVAL_VALUE: {
      return {
        ...state,
        deformationRateIntervalValue: payload,
      }
    }

    case SET_BASE_MAP: {
      return {
        ...state,
        baseMap: payload,
      }
    }

    case SET_CENTER: {
      return {
        ...state,
        center: payload,
      }
    }

    case ZOOM_IN: {
      return {
        ...state,
        zoom: state.zoom + 0.5,
      }
    }

    case ZOOM_OUT: {
      return {
        ...state,
        zoom: state.zoom - 0.5,
      }
    }

    case SET_ZOOM: {
      return {
        ...state,
        zoom: payload,
      }
    }

    case SET_TILE_LOADING: {
      return {
        ...state,
        loadingTiles: state.loadingTiles + 1,
      }
    }

    case SET_TILE_LOADED: {
      return {
        ...state,
        loadedTiles: state.loadedTiles + 1,
      }
    }

    case SET_AREA_DRAWING: {
      return {
        ...state,
        clearAreaDrawing: false,
        isAreaDrawingEnabled: payload,
      }
    }

    case CLEAR_AREA_DRAWING: {
      return {
        ...state,
        isAreaDrawingEnabled: false,
        clearAreaDrawing: true,
      }
    }

    case SET_AREA: {
      return {
        ...state,
        selectedArea: payload,
      }
    }

    case SET_LEGEND_DATA: {
      return {
        ...state,
        legendData: payload,
      }
    }

    default:
      return state
  }
}

export default mapReducer
